// React
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';

class DialogConfirm extends React.PureComponent {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        close: PropTypes.func,
        callback: PropTypes.func,
        open: PropTypes.bool,
        text: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        title: PropTypes.string,
        fullScreen: PropTypes.bool
    };

    render() {
        const { fullScreen, title, close, open, callback } = this.props;
        const text = typeof this.props.text === 'string' ? [this.props.text] : this.props.text;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
            >
                <DialogTitle id='responsive-dialog-title'>{title}</DialogTitle>
                <DialogContent>{text.map((el, index) => <p key={`dialogRemoveText${index}`} style={{ fontSize: '15px' }}>{el}</p>)}</DialogContent>
                <DialogActions>
                    <IconButton color='secondary' onClick={close}>
                        <ClearIcon />
                    </IconButton>
                    <IconButton color='primary' onClick={() => {
                        callback();
                        close();
                    }}>
                        <DoneIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
});

export default withStyles(styles)(DialogConfirm);
